import Barrel from "./Barrel";

export default class StyleguideNode {
    children: StyleguideNode[];
    parentId: string | null | undefined;
    id: string;
    data: Barrel;
    index: number;
    selectableIndex: number | undefined;

    constructor(styleguide: Barrel, index: number) {
        this.id = styleguide._id;
        this.parentId = styleguide.parent;
        this.data = styleguide;
        this.children = [];
        this.index = index;
    }

    addChild(node: StyleguideNode) {
        this.children.push(node);
    }

    isRoot(): boolean {
        return !this.parentId;
    }

    isLeaf(): boolean {
        return this.children.length === 0;
    }

    isArchived(): boolean {
        return this.data.status === "archived";
    }
}
